export const translations = {
  pt: {
    nav: {
      home: 'Início',
      about: 'Sobre',
      services: 'Serviços',
      portfolio: 'Portfólio',
      contact: 'Contato'
    },
    hero: {
      title: 'Consultoria Empresarial em Processos, Custos e Pricing',
      subtitle: 'A SMARTIN Consultoria entrega soluções estratégicas em Processos, Custos Gerenciais, Contribuição Marginal e Pricing — ajudando empresas a alcançarem alta performance operacional e financeira.',
      cta: 'Falar com um Consultor',
      location: 'Londrina - Paraná'
    },
    clients: {
      title: 'Experiências Profissionais e Parceiros SMARTIN',
      subtitle: ''
    },
    about: {
      title: 'Sobre a SMARTIN Consultoria',
      text: 'A SMARTIN Consultoria nasceu da união entre "Smart" (Específico, Mensurável, Atingível, Relevante e com Prazo Definido) e "Martins", criando uma marca que representa inteligência estratégica e tradição profissional. Há mais de uma década, oferecemos consultoria empresarial completa, unindo processos bem estruturados, visão analítica e gestão econômica financeira estratégica. Nossa missão é ser um agente de transformação positiva e duradoura na indústria nacional, unindo inteligência de dados, custos, contribuição marginal e pricing com excelência operacional de maneira a conduzir a empresa a tomar decisões estratégicas com base em dados sólidos e consistentes. Porque, no fim, a tese é simples (e prática): processo gera custo; custo define contribuição; contribuição governa preço; e preço sustenta caixa.',
      experience: 'Anos de Experiência',
      clients: 'Clientes Atendidos',
      projects: 'Projetos Concluídos'
    },
    services: {
      title: 'Nossos Serviços de Consultoria',
      processes: {
        title: 'Consultoria em Processos',
        description: 'Utilizamos como base o sistema WCM (World Class Manufacturing) e Lean Manufacturing. O objetivo é desenvolver o sistema de gestão da empresa, do estratégico ao operacional, de maneira a orientar decisões com base em dados reais e consistentes, evoluindo para projetos de melhoria contínua à fim de reduzir desperdícios (custos como perdas e retrabalhos), melhorar o nível de satisfação dos clientes e otimizar fluxos.',
        items: [
          'Mapeamento e reformulação do fluxo da empresa',
          'Desenvolvimento de sistema de coleta de informações',
          'Aplicação de inteligência de dados',
          'Desenvolvimento de relatórios de disponibilidade, eficiência e perdas',
          'Elaboração de Procedimentos Operacionais Padrão (POP)',
          'Treinamento e capacitação de equipe',
          'Aplicação de sistema de gerenciamento de rotinas'
        ]
      },
      costs: {
        title: 'Custos Gerenciais',
        description: 'Estruturamos análises de custos que dão clareza à operação e embasam decisões estratégicas. Auxiliamos empresas a entenderem seus custos reais, margens, eficiência e rentabilidade.',
        items: [
          'Estruturação de centros de custos',
          'Análise de custos diretos e indiretos',
          'Avaliação de lucratividade por produto/serviço',
          'Relatórios gerenciais de custo',
          'Indicadores de eficiência operacional'
        ]
      },
      pricing: {
        title: 'Contribuição Marginal e Pricing',
        description: 'Desenvolvemos análises profundas de margem de contribuição e modelos de pricing orientados por dados. Ajudamos empresas a formarem preços de forma estratégica, maximizando lucro e competitividade.',
        items: [
          'Cálculo de margem de contribuição',
          'Análise de ponto de equilíbrio',
          'Formação de preços (Pricing) com base técnica',
          'Precificação por valor, custo e mercado',
          'Estratégias de lucratividade e elasticidade de preço'
        ]
      }
    },
    portfolio: {
      title: 'Portfólio e Metodologias Aplicadas',
      delivered: {
        title: 'Serviços Entregues',
        items: [
          'Rotina de gerenciamento geral baseada em dados',
          'Capacitação de equipe em Processos e Custos Gerenciais',
          'Projetos de melhoria contínua',
          'Restruturação de Sistema de Custeio Real vs Standard compatível com Sistema Contábil',
          'Análise de Rentabilidade e Contribuição Marginal',
          'Estruturação de modelos de pricing'
        ]
      },
      methodologies: {
        title: 'Metodologias Utilizadas',
        description: 'A combinação entre BPM e Lean nos permite detectar desperdícios e estruturar fluxos eficientes, proporcionando ganhos reais de desempenho operacional e financeiro.',
        items: [
          { name: 'BPM', description: 'Business Process Management' },
          { name: 'Lean', description: 'Eliminação de desperdícios' },
          { name: 'Kaizen', description: 'Melhoria contínua' },
          { name: 'PDCA', description: 'Plan-Do-Check-Act' },
          { name: 'WCM', description: 'Excelência em Manufatura' },
          { name: 'Análise Financeira', description: 'Custos e Pricing' }
        ]
      }
    },
    contact: {
      title: 'Entre em Contato',
      subtitle: 'Estamos prontos para transformar seus processos e contabilidade',
      form: {
        name: 'Nome',
        email: 'E-mail',
        phone: 'Telefone',
        company: 'Empresa',
        message: 'Mensagem',
        send: 'Enviar Mensagem',
        sending: 'Enviando...',
        success: 'Mensagem enviada com sucesso!',
        error: 'Erro ao enviar mensagem. Tente novamente.'
      },
      info: {
        location: 'Londrina - Paraná',
        email: 'contato@smartinconsultoria.com.br',
        phone: '+55 43 99104-5996'
      }
    },
    footer: {
      about: 'Sobre a SMARTIN',
      description: 'Consultoria empresarial especializada em Processos, Custos Gerenciais e Pricing com mais de 10 anos de experiência no mercado.',
      services: 'Serviços',
      contact: 'Contato',
      rights: 'Todos os direitos reservados.',
      privacy: 'Política de Privacidade',
      terms: 'Termos de Uso'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      portfolio: 'Portfolio',
      contact: 'Contact'
    },
    hero: {
      title: 'Business Consulting in Process, Costs and Pricing',
      subtitle: 'For over 10 years, SMARTIN Consulting delivers strategic solutions in Process, Management Costs, Contribution Margin and Pricing — helping companies achieve high operational and financial performance.',
      cta: 'Talk to a Consultant',
      location: 'Londrina - Paraná, Brazil'
    },
    clients: {
      title: 'Professional Experiences and SMARTIN Partners',
      subtitle: ''
    },
    about: {
      title: 'About SMARTIN Consulting',
      text: 'SMARTIN Consulting was born from the union of "Smart" (Specific, Measurable, Achievable, Relevant, and Time-bound) and "Martins", creating a brand that represents strategic intelligence and professional tradition. For over a decade, we offer complete business consulting, combining well-structured processes, analytical vision, and strategic economic and financial management. Our mission is to be an agent of positive and lasting transformation in the national industry, combining data intelligence, costs, contribution margin, and pricing with operational excellence to lead companies to make strategic decisions based on solid and consistent data. Because, in the end, the thesis is simple (and practical): process generates cost; cost defines contribution; contribution governs price; and price sustains cash flow.',
      experience: 'Years of Experience',
      clients: 'Clients Served',
      projects: 'Completed Projects'
    },
    services: {
      title: 'Our Consulting Services',
      processes: {
        title: 'Process Consulting',
        description: 'We use the WCM (World Class Manufacturing) and Lean Manufacturing systems as a foundation. The goal is to develop the company\'s management system, from strategic to operational, in order to guide decisions based on real and consistent data, evolving into continuous improvement projects to reduce waste (costs such as losses and rework), improve customer satisfaction levels, and optimize flows.',
        items: [
          'Company flow mapping and reformulation',
          'Information collection system development',
          'Data intelligence application',
          'Availability, efficiency, and loss reports development',
          'Standard Operating Procedures (SOP) development',
          'Team training and capacity building',
          'Routine management system implementation'
        ]
      },
      costs: {
        title: 'Management Costs',
        description: 'We structure cost analysis that brings clarity to operations and supports strategic decisions. We help companies understand their real costs, margins, efficiency and profitability.',
        items: [
          'Cost center structuring',
          'Direct and indirect cost analysis',
          'Product/service profitability assessment',
          'Management cost reports',
          'Operational efficiency indicators'
        ]
      },
      pricing: {
        title: 'Contribution Margin and Pricing',
        description: 'We develop deep contribution margin analysis and data-driven pricing models. We help companies form prices strategically, maximizing profit and competitiveness.',
        items: [
          'Contribution margin calculation',
          'Break-even analysis',
          'Technical-based pricing',
          'Value, cost and market-based pricing',
          'Profitability and price elasticity strategies'
        ]
      }
    },
    portfolio: {
      title: 'Portfolio and Applied Methodologies',
      delivered: {
        title: 'Delivered Services',
        items: [
          'Data-based general management routine',
          'Team training in Processes and Management Costs',
          'Continuous improvement projects',
          'Actual vs Standard Costing System restructuring compatible with Accounting System',
          'Profitability and Contribution Margin Analysis',
          'Pricing model structuring'
        ]
      },
      methodologies: {
        title: 'Methodologies Used',
        description: 'The combination of BPM and Lean allows us to detect waste and structure efficient flows, providing real gains in operational and financial performance.',
        items: [
          { name: 'BPM', description: 'Business Process Management' },
          { name: 'Lean', description: 'Waste elimination' },
          { name: 'Kaizen', description: 'Continuous improvement' },
          { name: 'PDCA', description: 'Plan-Do-Check-Act' },
          { name: 'WCM', description: 'Manufacturing Excellence' },
          { name: 'Financial Analysis', description: 'Costs and Pricing' }
        ]
      }
    },
    contact: {
      title: 'Get in Touch',
      subtitle: 'We are ready to transform your processes and accounting',
      form: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        company: 'Company',
        message: 'Message',
        send: 'Send Message',
        sending: 'Sending...',
        success: 'Message sent successfully!',
        error: 'Error sending message. Please try again.'
      },
      info: {
        location: 'Londrina - Paraná, Brazil',
        email: 'contato@smartinconsultoria.com.br',
        phone: '+55 43 99104-5996'
      }
    },
    footer: {
      about: 'About SMARTIN',
      description: 'Business consulting specialized in Process, Management Costs and Pricing with over 10 years of market experience.',
      services: 'Services',
      contact: 'Contact',
      rights: 'All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Use'
    }
  }
};